
import React  from 'react'
// BrowserRouter as Router,
import { Route, Switch, HashRouter } from 'react-router-dom';


// containers
import TheLayout from './container/TheLayout';

const templateLoading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const App = () => {

  return (
    <HashRouter>
      <React.Suspense fallback={templateLoading}>
        <Switch>
          <Route path="/" name="Layaout" component={TheLayout} />
        </Switch>
      </React.Suspense>
    </HashRouter>
  )
}

export default App
